import type { RatingTag } from '../leagues/rating-chip';

export interface RatedEntrant {
  singlesRating: number | null;
  doublesRating: number | null;
}

export interface RatedRegistration {
  id: number;
  player: RatedEntrant;
  partner: RatedEntrant | null;
}

export function ratingForTag(entrant: RatedEntrant, tag: RatingTag): number | null {
  return tag === 'D' ? entrant.doublesRating : entrant.singlesRating;
}

function registrationRating(registration: RatedRegistration, tag: RatingTag): number | null {
  const ratings = [registration.player, registration.partner]
    .filter((entrant): entrant is RatedEntrant => entrant != null)
    .map((entrant) => ratingForTag(entrant, tag))
    .filter((rating): rating is number => rating != null);

  if (ratings.length === 0) {
    return null;
  }

  return ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length;
}

export function sortByRating<T extends RatedRegistration>(registrations: T[], tag: RatingTag): T[] {
  return [...registrations].sort((left, right) => {
    const leftRating = registrationRating(left, tag);
    const rightRating = registrationRating(right, tag);

    if (leftRating == null && rightRating == null) {
      return left.id - right.id;
    }

    if (leftRating == null) {
      return 1;
    }

    if (rightRating == null) {
      return -1;
    }

    if (rightRating !== leftRating) {
      return rightRating - leftRating;
    }

    return left.id - right.id;
  });
}
